import { useEffect } from 'react';
import useModal from './useModal';

export default (isOpen: boolean, preventAutoFocus: boolean, onClose?: () => void) => {
    const { setActiveModalId } = useModal();

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.code === 'Escape' && isOpen) {
                const { activeElement } = document;

                if (preventAutoFocus && activeElement instanceof HTMLElement) {
                    activeElement.blur();
                }

                setActiveModalId(null);
                onClose?.();
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', onKeyDown);
        } else {
            window.removeEventListener('keydown', onKeyDown);
        }

        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isOpen, onClose, preventAutoFocus, setActiveModalId]);
};
